import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';

import { CardInformation } from 'reservations/payments/components/CardInformation';
import { ExpiredPayment } from 'reservations/payments/components/ExpiredPayment';

const UnderlinedButton = styled(Button)({
  textTransform: 'none',
  textDecoration: 'underline',
  marginTop: '2px',
  '&:hover': {
    backgroundColor: 'white'
  }
});

type Props = {
  id: string;
  cardType: string;
  cardLast4: string;
  cardExpMonth: number;
  cardExpYear: number;
  isExpirationValid: boolean;
  showRemoveButton: boolean;
  handleDelete: (id: string) => void;
};

export const SavedPaymentMethodLabel = ({
  id,
  cardType,
  cardLast4,
  cardExpMonth,
  cardExpYear,
  isExpirationValid,
  showRemoveButton,
  handleDelete
}: Props) => (
  <Box display="flex" flexDirection="row" alignItems="center">
    <CardInformation
      cardType={cardType}
      cardLast4={cardLast4}
      cardExpMonth={cardExpMonth}
      cardExpYear={cardExpYear}
      isExpirationValid={isExpirationValid}
    />
    <ExpiredPayment isExpirationValid={isExpirationValid} />
    <Box marginLeft="auto">
      {showRemoveButton && (
        <UnderlinedButton
          onClick={() => {
            handleDelete(id);
          }}
        >
          Remove
        </UnderlinedButton>
      )}
    </Box>
  </Box>
);
